import { createSlice } from '@reduxjs/toolkit'
import { gameClose, userLogin } from 'redux-store/thunk/auth.thunk'
import { fetchUserInformation } from 'redux-store/thunk/user.thunk'
import { getPayloadFromToken } from 'utils/common-functions/index'

const defaultAuthState = {
  creditWalletWaitQueue: [],
  creditDemoWalletWaitQueue: [],
  userInfo: null,
  userDetails: null,
  currencyId: null,
  currencyCode: null,
  isLoggedIn: false,
  showName: false,
  demoMode: false,
  demoWallet: { balance: 3000, currency: 'FUN' }
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState: defaultAuthState,
  reducers: {
    setUserInfo: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload
      }
    }),
    setDemoMode: (state, action) => {
      return {
        ...state,
        demoMode: action.payload,
        currencyCode: state.demoWallet.currency
      }
    },
    debitBalance: (state, { payload }) => {
      const debitAmt = Number(payload)
      const _userInfoWallet = { ...state.userInfo.wallet }
      if (debitAmt) {
        _userInfoWallet.balance = minus(_userInfoWallet.balance, debitAmt)
      }
      return ({
        ...state,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      })
    },
    creditBalance: (state, { payload }) => {
      const creditAmt = Number(payload)
      const _userInfoWallet = { ...state.userInfo.wallet }
      if (creditAmt) {
        _userInfoWallet.balance = plus(_userInfoWallet.balance, creditAmt)
      }
      return ({
        ...state,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      })
    },
    updateDemoWalletBalanceForBetPlace: (state, action) => {
      const newBalance = (action.payload.operation === 'add') ? state.demoWallet.balance + Number(action.payload.amount) : state.demoWallet.balance - Number(action.payload.amount)

      return {
        ...state,
        demoWallet: { ...state.demoWallet, balance: newBalance }
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.fulfilled, (state, action) => {
        const { user, wallet, accessToken } = action.payload
        const payload = getPayloadFromToken(accessToken)
        const currencyId = payload?.currencyId
        const currencyCode = payload?.currencyCode
        return {
          ...state,
          currencyId,
          currencyCode,
          userInfo: { user, wallet },
          token: accessToken,
          isLoggedIn: true
        }
      })
      .addCase(fetchUserInformation.fulfilled, (state, action) => {
        return {
          ...state,
          userDetails: action.payload
        }
      })
      .addCase(gameClose.fulfilled, (state, action) => {
        return defaultAuthState
      })
  }
})

export const {
  setUserInfo, setDemoMode, updateDemoWalletBalanceForBetPlace, debitBalance, creditBalance
} = authSlice.actions

export default authSlice.reducer
